import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../../common/Utils";
import {Controller, useForm} from 'react-hook-form';
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import {
  getInventoryMemberships,
  getMemberPerkTypes,
  getPerkInventoryTypes,
  getPerkRecurrenceTypes,
  saveMemberPerk
} from "../../common/api/InventoryApi";
import {Divider, InputAdornment, NativeSelect} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {CONSTANTS} from "../../common/constants";
import AutoCompleteProductSearch from "./AutoCompleteProductSearch";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import {CompanyContext} from "../../../lib/CompanyContext";
import {useAccess} from "../../../lib/AccessProvider";

export default function ManageMemberPerkModal({perk, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [perkTypes, setPerkTypes] = useState([]);
  const [recurrenceTypes, setRecurrenceTypes] = useState([]);
  const [perkInventory, setPerkInventory] = useState(perk?.inventory);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(perk)
  });

  const [memberships, setMemberships] = useState([]);
  const [inventoryTypes, setInventoryTypes] = useState(null);

  const loadPerkTypes = () => {
    getMemberPerkTypes().then(result => {
      setPerkTypes(result);
    });
  }

  const getInventoryTypesFn = () => {
    let _types = [];
    let _cafeTypes = [];
    getPerkInventoryTypes().then(result => {
      setInventoryTypes(result);
    });
  }

  const savePerkFn = (perk) => {
    let _d = {...perk};


    if (!_d?.assignedMemberships) {
      _d.assignedMemberships = [];
    } else {
      let assignedMemberships = [];
      for (let j in _d.assignedMemberships) {
        assignedMemberships.push(parseInt(_d.assignedMemberships[j], 10))
      }
      _d.assignedMemberships = assignedMemberships;
    }

    _d.inventory = {...perkInventory};
    if (!_d?.assignedInventoryTypeIds) {
      _d.assignedInventoryTypeIds = [];
    } else {
      let assignedInventoryTypeIds = []
      for (let j in _d.assignedInventoryTypeIds) {
        assignedInventoryTypeIds.push(parseInt(_d.assignedInventoryTypeIds[j], 10));
      }
      _d.assignedInventoryTypeIds = assignedInventoryTypeIds;
    }

    saveMemberPerk(_d).then(result => {
      handleSave(_d);
    });
  }

  const [unlimitedUsage, setUnlimitedUsage] = useState(perk?.unlimitedUsage);

  const toggleUnlimitedUsage = (e) => {
    setUnlimitedUsage(e.target.checked);
  }

  const loadRecurrenceTypes = () => {
    getPerkRecurrenceTypes().then(result => {
      setRecurrenceTypes(result);
    });
  }

  const loadMembershipInventoryFn = () => {
    getInventoryMemberships().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setMemberships(result);
      }
    });
  }

  const [perkTypeId, setPerkTypeId] = useState(perk?.perkType?.id || -1);

  useEffect(() => {
    loadMembershipInventoryFn();
    loadPerkTypes();
    loadRecurrenceTypes();
    getInventoryTypesFn();
  }, [])

  const [recurrenceTypeId, setRecurrenceTypeId] = useState(perk?.recurrenceType?.id);
  const [timeRestricted, setTimeRestricted] = useState(perk?.timeRestricted);
  const [frequencyRestricted, setFrequencyRestricted] = useState(perk?.frequencyRestricted);

  const [orgAccess, setOrgAccess] = useState(null);

  const {getAccess} = useAccess();
  useEffect(() => {
    setOrgAccess(getAccess());
  }, []);

  const currentCompany = (c) => {
    return c.companyId === companyContext?.company?.companyId;
  }

  const perkFrequencyTypes = [
    {
      id: 1,
      name: 'Day'
    },
    {
      id: 2,
      name: 'Week'
    },
    {
      id: 3,
      name: 'Month'
    }
  ]

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(savePerkFn)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{perk?.guid ? 'Edit' : 'Add'} Perk</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        required
                        variant="outlined" type="text"
                        {...register('name')}
                        placeholder="Enter Perk Title"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="name"
                        label="Perk Title"/>

                    </div>
                  </Col>

                </Row>
                <Row>
                  <Col sm={6} xs={12}>

                    {recurrenceTypes?.length > 0 && <>
                      <div className="form-group native-margin-fix">
                        <label htmlFor={"membership"} className={"native-label mt-4"}>Recurrence</label>
                        <NativeSelect
                          autoComplete="off"
                          variant="outlined"
                          required
                          id={'recurrenceType'} name={'perkRecurrence'} className={'form-control'}
                          {...register('recurrenceType.id', {
                            valueAsNumber: true,
                            required: true,
                            onChange: (e) => {
                              setRecurrenceTypeId(parseInt(e.target.value, 10))
                            },
                            validate: (value) => value > 0 || 'Please select a valid option',
                          })}>
                          <option value={-1}>Choose</option>
                          {
                            recurrenceTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>
                        {recurrenceTypeId === CONSTANTS.PERK_RECURRENCE_TYPE.INITIAL &&
                          <small><Icon>help</Icon> Initial perks will be applied only once at time of membership
                            purchase.</small>
                        }

                        {recurrenceTypeId === CONSTANTS.PERK_RECURRENCE_TYPE.RECURRING &&
                          <small><Icon>help</Icon> Recurring perks will be applied to any recurring memberships each
                            billing cycle.</small>
                        }

                      </div>
                    </>
                    }
                  </Col>
                  <Col sm={6} xs={12}>
                    {perkTypes?.length > 0 && <>
                      <div className="form-group native-margin-fix">
                        <label htmlFor={"perkType"} className={"native-label mt-4"}>Perk Type</label>
                        <NativeSelect
                          required
                          autoComplete="off"
                          variant="outlined"
                          required
                          id={'perkType'} name={'perkType'} className={'form-control'}
                          {...register('perkType.id', {
                            valueAsNumber: true,
                            required: true,
                            onChange: (e) => {
                              setPerkTypeId(parseInt(e.target.value, 10))
                            },
                            validate: (value) => value > 0 || 'Please select a valid option',
                          })}>
                          <option value={-1}>Choose</option>
                          {
                            perkTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>
                      </div>
                    </>
                    }
                    <div className="form-group mt-4">
                      {perkTypeId === CONSTANTS.PERK_TYPE.PRODUCT && <>
                        <Controller
                          name="inventory"
                          control={control}
                          rules={{required: "Inventory is required"}}
                          render={({field, fieldState}) => (
                            <AutoCompleteProductSearch
                              label="Search Products"
                              value={field.value}              // Controlled value from RHF
                              onChange={field.onChange}        // Update form state on change
                              fieldState={fieldState}          // For error display
                              defaultValue={perk?.inventory}  // Optional initial value
                              onSelect={(selected) => {
                                field.onChange(selected);      // Update RHF state on selection
                                setPerkInventory(selected);    // Your local state handler if needed
                              }}
                            />
                          )}
                        />

                      </>
                      }
                      {perkTypeId === CONSTANTS.PERK_TYPE.DISCOUNT && <>
                        <MDInput type="text" step={"0.01"} required={perkTypeId === CONSTANTS.PERK_TYPE.DISCOUNT}
                                 {...register('discountPercentage', {
                                   valueAsDouble: true,
                                   onChange: (e) => {
                                     // let v = parseFloat(e.target.value.replace(/[^0-9.]/g, ''));
                                     let v = e.target.value.replace(/[^0-9.]/g, '');
                                     if (parseFloat(v) > 100) {
                                       v = 100
                                     }
                                     e.target.value = v;
                                   }
                                 })}
                                 disabled={perkTypeId !== CONSTANTS.PERK_TYPE.DISCOUNT}
                                 autoComplete="off"
                                 variant="outlined"
                                 min={0}
                                 max={100}
                                 InputLabelProps={{shrink: true}}
                                 placeholder={"Enter Discount Percent"}
                                 className="form-control" id="discountPercentage"
                                 label="Discount Percentage"/>
                      </>
                      }

                      {perkTypeId === CONSTANTS.PERK_TYPE.CREDIT && <>
                        <MDInput type="number" step={1} required={perkTypeId === CONSTANTS.PERK_TYPE.CREDIT}
                                 {...register('storeCreditValue', {
                                   valueAsNumber: true
                                 })}
                                 disabled={perkTypeId !== CONSTANTS.PERK_TYPE.CREDIT}
                                 autoComplete="off"
                                 variant="outlined"
                                 InputLabelProps={{shrink: true}}
                                 placeholder={"Enter Credit Value"}
                                 className="form-control" id="storeCreditValue"
                                 label="Credit Value"/>
                      </>
                      }

                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={12}>
                    <Divider/>

                    <p className={'m-0'}><label>
                      <Checkbox defaultChecked={perk?.unlimitedUsage}
                                {...register('unlimitedUsage', {
                                  onChange: toggleUnlimitedUsage
                                })} /> Unlimited Usage</label></p>
                    <small><Icon>coffee_cup</Icon> Allows for unlimited usage of perk, ie. ongoing discounts while
                      valid membership. </small>
                  </Col>
                </Row>

                {unlimitedUsage && <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">
                      <p className={'m-0'}><label>
                        <Checkbox defaultChecked={perk?.frequencyRestricted}
                                  {...register('frequencyRestricted', {
                                    onChange: ((e) => {
                                      setFrequencyRestricted(e.target.checked)
                                    })
                                  })} /> Unlimited Frequency Restrictions</label></p>
                      <small><HistoryToggleOffIcon/> Set frequency usage restrictions for unlimited perks, ie maximum 1
                        cup of coffee per day.</small>
                    </div>
                  </Col>

                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">

                      {frequencyRestricted && <>
                        <MDInput type="number" step={1} required={frequencyRestricted}
                                 {...register('frequencyRestriction', {
                                   valueAsNumber: true,
                                   onChange: (e) => {
                                     let k = parseInt(e.target.value);
                                     e.target.value = k;
                                   }
                                 })}
                                 disabled={!frequencyRestricted}
                                 autoComplete="off"
                                 variant="outlined"
                                 min={0}
                                 max={100}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-clock'}></span>
                                   </InputAdornment>,
                                   endAdornment: <InputAdornment position="end">
                                     <NativeSelect
                                       sx={{
                                         width: '160px',
                                         position: 'relative',
                                         right: '-14px'
                                       }}
                                       variant="outlined"
                                       disabled={!frequencyRestricted}
                                       id={'frequencyRestrictedType'}
                                       name={'frequencyRestrictedType'}
                                       defaultValue={-1}
                                       className={'form-control'}
                                       {...register('frequencyRestrictedType', {
                                         valueAsNumber: true,
                                         min: 1,
                                         required: frequencyRestricted
                                       })}>
                                       <option value={-1}>Time</option>
                                       {
                                         CONSTANTS.PERK_FREQUENCY_TYPES.map((c) =>
                                           <option value={c.id} key={c.id}>
                                             {c.name}
                                           </option>)
                                       }
                                     </NativeSelect>
                                   </InputAdornment>
                                 }}
                                 placeholder={"Perk usage frequency limit"}
                                 className="form-control" id="frequencyRestriction"
                                 label="Perk usage frequency limit"/>
                      </>}
                    </div>
                  </Col>

                </Row>}

                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">
                      <p className={'m-0'}><label>
                        <Checkbox defaultChecked={perk?.timeRestricted}
                                  {...register('timeRestricted', {
                                    onChange: ((e) => {
                                      setTimeRestricted(e.target.checked)
                                    })
                                  })} /> Time Restricted</label></p>
                      <small><Icon>clock</Icon> Member Perk must be used in designated time period.</small>
                    </div>
                  </Col>

                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">

                      {timeRestricted && <>
                        <MDInput type="number" step={1} required={timeRestricted}
                                 {...register('expirationDays', {
                                   valueAsNumber: true,
                                   onChange: (e) => {
                                     let k = parseInt(e.target.value);
                                     e.target.value = k;
                                   }
                                 })}
                                 disabled={!timeRestricted}
                                 autoComplete="off"
                                 variant="outlined"
                                 min={0}
                                 max={100}
                                 InputLabelProps={{shrink: true}}
                                 placeholder={"Perk Expires in Days"}
                                 className="form-control" id="expirationDays"
                                 label="Perk Expiration in Days"/>
                      </>}
                    </div>
                  </Col>
                  <Divider/>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="form-group mt-4">
                      <p><b>Assigned Memberships</b></p>
                      <Grid container>
                        {
                          memberships?.map((c) =>
                            <Grid item xs={12} sm={6} key={c.id}>
                              <label>
                                <Checkbox
                                  defaultChecked={perk?.assignedMemberships?.indexOf(c.id) > -1}
                                  {...register('assignedMemberships[]', {})}
                                  value={parseInt(c.id, 10)} key={c.id}/>
                                {c.name}
                              </label>
                            </Grid>
                          )
                        }
                      </Grid>
                    </div>
                  </Col>
                </Row>

                {perkTypeId === CONSTANTS.PERK_TYPE.DISCOUNT && <Row>
                  <Col xs={12}>
                    <div className="form-group mt-4">
                      <p><b>Discounted Inventory Types</b></p>
                      <Grid container>
                        {
                          inventoryTypes?.companyPerks.sort((a, b) => currentCompany(a) ? -1 : a.companyName.localeCompare(b.companyName))
                            .filter((entry) => (currentCompany(entry) || orgAccess?.orgOwner) ? true : false).map((entry, idx) => {
                            return (
                              <Grid container key={idx}>
                                {orgAccess?.orgOwner && <div style={{
                                  width: '100%',
                                  clear: 'both',
                                }}>
                                  <h6 className={'mt-2'}>{entry.companyName}</h6>
                                </div>
                                }

                                {entry?.inventoryTypes?.map((c) => {
                                    return (<Grid item sm={6} xs={12} key={c.id}>
                                      <label>
                                        <Checkbox
                                          defaultChecked={perk?.assignedInventoryTypeIds?.indexOf(c.id) > -1}
                                          {...register('assignedInventoryTypeIds[]', {})}
                                          value={parseInt(c.id, 10)} key={c.id}/>
                                        {c.name}
                                      </label>
                                    </Grid>)
                                  }
                                )}
                              </Grid>
                            )
                          })
                        }
                      </Grid>
                    </div>
                  </Col>
                </Row>
                }
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-4">

                      <textarea
                        rows={5}
                        {...register('description')}
                        className="form-control" id="description"
                        placeholder="Enter Description"/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}